import { ReactElement } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import styled from 'styled-components'

import { Column } from '@10xLabs/react-web/components/Column'
import { ArrowRightIcon } from '@10xLabs/react-web/components/Icons/ArrowRight'
import { Row } from '@10xLabs/react-web/components/Row'
import { MultiCityAutocomplete } from 'features/Cities/components/MultiCityAutocomplete'
import { GTCitySuggestion } from 'gql/types.generated'
import { ISelectCitiesProps } from './types'

const StyledArrowRightIcon = styled(ArrowRightIcon)<TSFixMe>`
  fill: #5d5c70;
  width: 24px;
  height: 14px;
`

const ArrowLeftIcon = styled(StyledArrowRightIcon)<TSFixMe>`
  transform: rotate(180deg);
`

const BothWay = (): ReactElement => {
  return (
    <div>
      <StyledArrowRightIcon />
      <ArrowLeftIcon />
    </div>
  )
}

const OneWay = (): ReactElement => {
  return (
    <div>
      <StyledArrowRightIcon />
    </div>
  )
}
const Pointer = styled.div<TSFixMe>`
  cursor: pointer;
`

const SplitColumn = styled(Column)<TSFixMe>`
  flex: 0.1;
  align-self: center;
  text-align: center;
`

const messages = defineMessages({
  selectCitiesOrigins: {
    id: 'fareRules.form.citiesOrigins.placeholder',
    defaultMessage: 'Select origin cities'
  },
  selectCitiesDestinations: {
    id: 'fareRules.form.citiesDestinations.placeholder',
    defaultMessage: 'Select destination cities'
  },
  allOriginsOption: {
    id: 'fareRules.form.citiesOrigins.all',
    defaultMessage: 'All origins'
  },
  allDestinationsOption: {
    id: 'fareRules.form.citiesDestinations.all',
    defaultMessage: 'All destinations'
  }
})
const SelectCities = (props: ISelectCitiesProps): ReactElement => {
  const { isReturn, disabled, originValue, destinationValue, handleReturn, onChange, touched, errors } = props
  const intl = useIntl()

  const handleCityOriginsChange = (cities: GTCitySuggestion[]): void => {
    onChange(
      cities.map((city) => {
        return {
          id: city.id,
          name: city.name,
          stateCode: city.stateCode || ''
        }
      }),
      'origin'
    )
  }

  const handleCityDestinationsChange = (cities: GTCitySuggestion[]): void => {
    onChange(
      cities.map((city) => {
        return {
          id: city.id,
          name: city.name,
          stateCode: city.stateCode || ''
        }
      }),
      'destination'
    )
  }

  return (
    <Row>
      <Column>
        <MultiCityAutocomplete
          id="cityOrigins"
          placeholder={intl.formatMessage(messages.selectCitiesOrigins)}
          values={originValue || []}
          onChange={(values: GTCitySuggestion[]): void => handleCityOriginsChange(values)}
          touched={touched?.cityOrigins}
          errors={errors?.cityOrigins}
          disabled={disabled}
        />
      </Column>
      <SplitColumn>
        <Pointer onClick={(): void => handleReturn(!isReturn)}>{isReturn ? <BothWay /> : <OneWay />}</Pointer>
      </SplitColumn>
      <Column>
        <MultiCityAutocomplete
          id="cityDestinations"
          placeholder={intl.formatMessage(messages.selectCitiesDestinations)}
          values={destinationValue || []}
          onChange={(values: GTCitySuggestion[]): void => handleCityDestinationsChange(values)}
          touched={touched?.cityDestinations}
          errors={errors?.cityDestinations}
          disabled={disabled}
        />
      </Column>
    </Row>
  )
}

export default SelectCities
